import { motion } from "framer-motion";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsaXNtfGVufDB8fHx8MTc4Mjk1MzA4OXww&ixlib=rb-4.1.0&q=85";

export const VisualPanel = () => {
  return (
    <aside
      className="hidden md:block col-span-5 relative min-h-screen border-l border-white/5 overflow-hidden"
      data-testid="visual-panel"
      aria-hidden="true"
    >
      <motion.div
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(0.35) brightness(0.55) contrast(1.05)",
        }}
      />

      {/* Deep vignette to blend into left panel */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, rgba(10,10,11,0.75) 0%, rgba(10,10,11,0.25) 30%, rgba(10,10,11,0) 60%, rgba(10,10,11,0.35) 100%), linear-gradient(180deg, rgba(10,10,11,0.4) 0%, rgba(10,10,11,0.1) 40%, rgba(10,10,11,0.5) 100%)",
        }}
      />

      {/* Corner rule marks */}
      <div className="absolute inset-8 border border-white/5 pointer-events-none" />

      {/* Coordinates label — decorative */}
      <div
        className="absolute bottom-10 right-10 font-mono-plex text-[10px] uppercase tracking-[0.3em] text-white/40 text-right"
        data-testid="visual-coordinates"
      >
        <div>N 34° 12' · W 118° 03'</div>
        <div className="mt-1 text-white/25">Signal · Latency · Stack</div>
      </div>

      {/* Vertical label — decorative */}
      <div
        className="absolute top-10 left-8 origin-top-left rotate-90 translate-x-8 font-mono-plex text-[10px] uppercase tracking-[0.5em] text-white/25 whitespace-nowrap"
        data-testid="visual-vertical-label"
      >
        Infrastructure · Automation · AI Implementation
      </div>
    </aside>
  );
};

export default VisualPanel;
